import { Header } from "semantic-ui-react";
import React from "react";
import "./MainHeader.css";

export const MainHeader = ({ title, subtitle }) => (
  <Header as="h1" className="main-header">
    {title}
    <Header.Subheader>{subtitle}</Header.Subheader>
  </Header>
);
